import { render, staticRenderFns } from "./Vipmanage.vue?vue&type=template&id=5f268faf&scoped=true&"
import script from "./Vipmanage.vue?vue&type=script&lang=js&"
export * from "./Vipmanage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f268faf",
  null
  
)

export default component.exports